import { AuthUser } from "@thrivecoin/authentication-v2/dist/types/lib/dynamic-auth/types";
import { createContext } from "react";

type AuthenticationContextType = {
  user?: AuthUser | null;
  loading: boolean;
  isAuthenticating: boolean;
  loginModal: () => void;
  logout: () => void;
  refreshUser: () => void;
  isWaitingWalletChangeWebhook: boolean;
};

const AuthenticationContext = createContext<AuthenticationContextType>({
  user: undefined,
  loading: true,
  isAuthenticating: false,
  loginModal: () => {},
  logout: () => {},
  refreshUser: () => {},
  isWaitingWalletChangeWebhook: false,
});

export default AuthenticationContext;
